/* eslint-disable no-console -- this module is the SDK's only console surface. */

const LOCAL_HOSTS = ['localhost', '127.0.0.1', '[::1]', '0.0.0.0'];

/** Developer machines get diagnostics for free; visitors of customer sites never do. */
function isLocalHost(): boolean {
  const host = typeof location === 'undefined' ? '' : location.hostname;
  return LOCAL_HOSTS.indexOf(host) !== -1 || /\.local$/i.test(host);
}

export interface Logger {
  enabled: boolean;
  debug: (message: string, ...rest: unknown[]) => void;
  warn: (message: string, ...rest: unknown[]) => void;
  error: (message: string, ...rest: unknown[]) => void;
}

const PREFIX = '[siteflow]';

export function createLogger(debug?: boolean): Logger {
  const enabled = debug === true || isLocalHost();
  return {
    enabled,
    debug: (message, ...rest) => {
      if (enabled) console.info(PREFIX, message, ...rest);
    },
    warn: (message, ...rest) => {
      if (enabled) console.warn(PREFIX, message, ...rest);
    },
    error: (message, ...rest) => {
      if (enabled) console.error(PREFIX, message, ...rest);
    },
  };
}
